import type { JSX , ReactNode } from "react";
import type { ChildrenProp } from "@charterindex/armoury-www";
import type { Services } from "../../../services/services";
import { useObservable } from "ecce-react";
import { Component } from "react";
import { ErrorDialog } from "./error-dialog";


export type ErrorBoundaryProps = ChildrenProp & {
	services: Services;
};
type ErrorBoundaryState = { hasError: boolean };
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	override componentDidCatch(error: Error): void {
		this.props.services.error.handleError("COMPONENT", error);
	}

	static getDerivedStateFromError(): ErrorBoundaryState {
		return { hasError: true };
	}

	override render(): ReactNode {
		return (
			<>
				{ !this.state.hasError && this.props.children }
				<ErrorBoundaryView services={ this.props.services }/>
			</>
		);
	}
}


const ErrorBoundaryView = (p: ErrorBoundaryProps): JSX.Element => {
	useObservable(p.services.auth, "activeUser");
	useObservable(p.services.error, "error");
	useObservable(p.services.error, "errorDetails");

	return (
		<ErrorDialog
			error={ p.services.error.error }
			admin={ p.services.auth.hasSomePermissions([ "ADMIN", "MASQUERADE" ]) }
			details={ p.services.error.errorDetails }
			onClickOk={ () => window.location.href = p.services.reference.setting("agentUrl") }
		/>
	);
};
